const SubsectionJob = {
  Commitment: [
    "Part-Time Job",
    "Full-Time Job",
    "Remote Job",
    "Onsite Job",
    "Hybrid Job",
    "Internship Job",
    "Volunteer Job"
  ].sort((a, b) => a.localeCompare(b)),
  Post_Duration: [
    "7 days",
     "14 days",
      "21 days",
      "30 days"].sort((a, b) => a.localeCompare(b)),
  Expert_Level: [
    "Internship Level",
    "Entry Level",
    "Intermediate Level",
    "Professional Level",
  ],
  Expert_Years: [
    "1-2 Years of Experience",
    "2-4 Years of Experience",
    "4-6 Years of Experience",
    "7+ Years of Experience",
  ].sort((a, b) => a.localeCompare(b)),

  Document_Req: ["Curriculum Vitae (CV)", "No, I have Website"],

  SalaryKES: [
    "KES 0 - KES 10,000",
    "KES 10,000 - KES 20,000",
    "KES 20,000 - KES 40,000",
    "KES 40,000 - KES 60,000",
    "KES 60,000 - KES 80,000",
    "KES 80,000 - KES 100,000",
    "KES 100,000 - KES 150,000",
    "KES 150,000 - KES 200,000",
    "KES 200,000 - KES 250,000",
    "KES 250,000 - KES  300,000",
    "KES 300,000 - KES 400,000",
    "KES 400,000 - KES 500,000",
    "KES 500,000 - KES 800,000",
    "KES 800,000 - KES 9000,000",
    "KES 900,000 - KES 1,000,000+",
  ],
  SalaryDollar: [
    "USD 0 - USD 100",
    "USD 100 - USD 200",
    "USD 200 - USD 400",
    "USD 400 - USD 600",
    "USD 600 - USD 800",
    "USD 800 - USD 1,000",
    "USD 1,000 - USD 1,500",
    "USD 1,500 - USD 2,000",
    "USD 2,000 - USD 2,500",
    "USD 2,500 - USD 3,000",
    "USD 3,000 - USD 4,000",
    "USD 4,000 - USD 5,0000",
    "USD 6,000 - USD 8,0000",
    "USD 8,000 - USD 10,0000",
    "USD 10,000 - USD 20,0000",
    "USD 20,000 - USD 30,0000",
    "USD 30,000 - USD 40,0000+",
    "USD 40,000 - USD 50,0000+",
  ],
};

export default SubsectionJob;